import React, { useState, createContext, useContext } from 'react';

/** @typedef {{
  apiPrefix: string,
}} PortalConfigState */

/** @type { React.Context<PortalConfigState> } */
const portalConfigContext = createContext(undefined);

/**
 * PortalConfigProvider
 */

/** @typedef {{
  config: PortalConfigState
}} PortalConfigProviderProps */

/** @type { React.FC<PortalConfigProviderProps> } */
export const PortalConfigProvider = (props) => {
  const { children, config: initialConfig } = props;

  /** @type { [PortalConfigState, React.Dispatch<PortalConfigState>]} */
  const [portalConfig, _setPortalConfig] = useState(initialConfig); // eslint-disable-line no-unused-vars

  return (
    <portalConfigContext.Provider value={portalConfig}>
      {children}
    </portalConfigContext.Provider>
  );
};

/**
 * usePortalConfig()
 */

export function usePortalConfig() {
  const ctx = useContext(portalConfigContext);
  if (ctx === undefined) {
    throw new Error(
      'usePortalConfig must be used within a PortalConfigProvider'
    );
  }
  return ctx;
}
